class NavigationDrawer extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.addEventListener('click', this.handleNavigation);
    window.addEventListener('resize', this.setHeightVarForPrimaryNavItems.bind(this));
    setTimeout(() => {
      this.setHeightVarForPrimaryNavItems();
    }, 500);
  }

  setHeightVarForPrimaryNavItems() {
    document.documentElement.style.setProperty('--header-primary-height', Math.round(document.querySelector('#masthead .header__level-3 nav').clientHeight) + 'px');
    console.log(Math.round(document.querySelector('.header__level-3 nav').clientHeight) + 'px');
  }

  handleNavigation(event) {
    const button = event.target.closest('.item.has-children');
    const backButton = event.target.closest('[data-panel="0"]');

    if (button) {
      if (button.querySelector("a[href='#']")) {
        return false;
      }
      const panelIndex = button.getAttribute('data-connected-panel');
      button.setAttribute('aria-expanded', 'true');
      this.openPanel(panelIndex);
    }

    if (backButton) {
      const parentButton = this.querySelector(`.item.has-children[data-connected-panel="${backButton.getAttribute('data-panel')}"]`);
      if (parentButton) {
        parentButton.setAttribute('aria-expanded', 'false');
      }
      this.resetNavigation();
    }
  }

  openPanel(panelIndex) {
    const panelListWrapper = this.querySelector('.mobile-nav__panel-list-wrapper');
    const panelWrappers = this.querySelectorAll('.mobile-nav__panel-wrapper');
    const mobilePanels = this.querySelectorAll('.mobile-nav__panel');

    panelWrappers.forEach(wrapper => {
      wrapper.setAttribute('hidden', '');
    });

    mobilePanels.forEach(panel => {
      panel.classList.remove('transitioned-behind', 'transitioned-top');
      panelListWrapper.style.removeProperty('height');
      panel.style.removeProperty('height');
    });
    
    const targetPanelWrapper = this.querySelector(`[data-level-2-panel="${panelIndex}"]`);
    if (targetPanelWrapper) {
      targetPanelWrapper.removeAttribute('hidden');
      setTimeout(() => {
        panelListWrapper.style.height = `${targetPanelWrapper.offsetHeight + 40}px`;
      }, 200);
    }
    
    if (mobilePanels.length > 0) {
      const firstPanel = mobilePanels[0];
      const lastPanel = mobilePanels[mobilePanels.length - 1];
      
      firstPanel.classList.add('transitioned-behind');
      firstPanel.style.height = '0';
      
      lastPanel.classList.add('transitioned-top');
    }
  }

  resetNavigation() {
    const panelWrappers = this.querySelectorAll('.mobile-nav__panel-wrapper');
    const mobilePanels = this.querySelectorAll('.mobile-nav__panel');
    const panelListWrapper = this.querySelector('.mobile-nav__panel-list-wrapper');

    panelWrappers.forEach(wrapper => {
      wrapper.setAttribute('hidden', '');
    });

    mobilePanels.forEach(panel => {
      panel.classList.remove('transitioned-behind', 'transitioned-top');
      panelListWrapper.style.removeProperty('height');
      panel.style.removeProperty('height');
    });

    // Reset all buttons' aria-expanded
    this.querySelectorAll('.item.has-children').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  }
}
if (!window.customElements.get('navigation-drawer')) {
  window.customElements.define('navigation-drawer', NavigationDrawer);
}